'use es6';

export const FETCH_PAGE_LIMIT_REQUEST = 'FETCH_PAGE_LIMIT_REQUEST';
export const FETCH_MLANG_PAGES_LIMIT_REQUEST = 'FETCH_MLANG_PAGES_LIMIT_REQUEST';
export const FETCH_CRM_OBJECT_TYPES_REQUEST = 'FETCH_CRM_OBJECT_TYPES_REQUEST';
export const FETCH_CRM_OBJECT_SCHEMA_REQUEST = 'FETCH_CRM_OBJECT_SCHEMA_REQUEST';